import styled from 'styled-components';

import { colors, fontFamily, zIndex } from '../../ui/variables';

export const TypesSelectStyle = styled.div`
  background-color: ${colors.veryDarkGrayishBlue};
  border-radius: 12px;
  padding: 0 16px;
  position: relative;
  width: 100%;

  &.show {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .show-hide-list {
      .icon {
        transform: translateY(-50%) rotate(180deg);
      }
    }

    .search-input-wrapper {
      display: block;
    }

    .types-list-container {
      ${zIndex.space};
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;

    }
  }

  .search-input-wrapper {
    display: none;
    padding: 0px 1px;
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: ${colors.veryDarkGrayishBlue};
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;

    .color-search-input {
      flex: 1;
      width: 90%;
      padding: 8px 12px;
      background-color: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 6px;
      color: ${colors.verySoftBlue};
      font-family: ${fontFamily.sourceSansPro.regular};
      font-size: 14px;
      outline: none;
      transition: all 0.3s ease;

      &::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }

      &:focus {
        border-color: rgba(255, 255, 255, 0.4);
        background-color: rgba(255, 255, 255, 0.08);
      }
    }

    .icon {
      
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;

      svg {
        fill: ${colors.white};
        height: auto;
        width: 100%;
      }
    }
  }

  .show-hide-list {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.verySoftBlue};
    font-size: 14px;
    line-height: 24px;
    position: relative;
    text-align: left;
    width: 100%;

    .show-hide-selected {
      padding: 12px 36px 12px 30px;
      position: relative;
      white-space: nowrap;

      .selected-box {
        border-radius: 6px;
        border-style: solid;
        border-width: 1px;
        height: 22px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 22px;

        svg {
          fill: ${colors.verySoftBlue};
          height: auto;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
        }
      }
    }

    .show-hide-unselected {
      padding: 12px 48px 12px 0;
      white-space: nowrap;
    }

    .icon {
      
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;

      svg {
        fill: ${colors.white};
        height: auto;
        width: 100%;
      }
    }
  }

  .group-label{
    margin-bottom: 20px;
    font-family: SourceSansPro;
    font-weight: normal;
    font-style: normal;
    color: #F9FAFF;
    line-height: 18px;
    cursor: pointer;
  }

  .group-label:hover {
    color: #a0a0a0;
  }


  .types-list-container {
    background-color: ${colors.veryDarkGrayishBlue};
    bottom: 0;
    left: 0;
    max-height: 600px;
    overflow-y: auto;
    padding: 0 16px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transform: translateY(100%);
    width: 100%;
    padding-top: 5px;

    .type-option {
      display: block;
      text-align: left;
      word-wrap: break-word;
      white-space: normal; 

      align-items: center;
      flex-wrap: nowrap;
      height: 24px;
      justify-content: space-between;
      margin-bottom: 16px;
      padding-left: 32px;
      position: relative;
      width: 100%;

      &.selected {
        .option-box {
          svg {
            fill: ${colors.verySoftBlue};
          }
        }

        .option-name {
          ${fontFamily.sourceSansPro.bold};
        }
      }

      &.type-any {
        border-bottom: solid 1px ${colors.veryPaleBlue};
        height: 40px;
        padding-bottom: 16px;

        .option-box {
          transform: translateY(calc(-50% - 8px));
        }
      }

      .option-box {
        border-radius: 6px;
        border-style: solid;
        border-width: 1px;
        height: 22px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 22px;

        svg {
          fill: transparent;
          height: auto;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
        }
      }

      .option-name {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.verySoftBlue};
        font-size: 14px;
        line-height: 18px;
      }

      .option-subtypes-count {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.lightGray};
        font-size: 10px;
        line-height: 13px;
      }
    }
  }

  // .type-option:not(:last-child) {
  //   margin-bottom: 25px;
  // }

  .no-results {
    padding: 20px 16px;
    text-align: center;
    color: ${colors.lightGray};
    font-size: 14px;
    line-height: 18px;
  }
`;
